import { sortObjectByKey } from '@utils/common';

import { TSelectOption } from '@interfaces/components/componentTypes';

export function generateSelectOptions<T>({
	data,
	value,
	label,
	sort,
	subTextProp,
}: {
	data: T;
	label: string | string[];
	value: string;
	sort?: boolean;
	subTextProp?: string;
}): TSelectOption[] {
	if (!Array.isArray(data)) return [];

	const options = data.filter(item => !!item).map(item => {
		const labelPrepared = Array.isArray(label)
			? label.reduce<string>((acc, curr, idx) => {
				if (idx === 0) acc = acc + `${item[curr]}`;
				else {
					const twiceDeepPropSelectorArr = curr.split('.');

					if (twiceDeepPropSelectorArr.length === 1) {
						acc = acc + ` ${item[curr]}`;
					} else {
						acc = acc + ` ${item[twiceDeepPropSelectorArr[0]][twiceDeepPropSelectorArr[1]]}`;
					}
				}

				return acc;
			}, '')
			: item[label];

		if (subTextProp) {
			return {
				value: item[value],
				label: labelPrepared,
				subText: item[subTextProp],
			};
		}

		return {
			value: item[value],
			label: labelPrepared,
		};
	});

	return sort
		? sortObjectByKey(options, 'label')
		: options;
}
